import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Insurance',
    description: 'Insurance page title',
    id: 'L7heLj',
  },
  helpLinkToS: {
    defaultMessage: 'Learn more about <a>insurance settings and terms of service</a>.',
    description: 'link to terms of service, more details about insurance',
    id: 'x/ruQS',
  },
  listLearnMore: {
    defaultMessage: 'Learn more about coverage and terms',
    description: 'list item linking to the coverage and terms help link',
    id: 'gygOIw',
  },
  linksCoverage: {
    defaultMessage: 'Coverage and terms of service',
    description: 'link to terms of service and coverage details',
    id: 'B0txTw',
  },
  linksFileClaim: {
    defaultMessage: 'How to file a claim',
    description: 'link to file a claim',
    id: 'Cf+YJi',
  },
  linksInsuredShipments: {
    defaultMessage: 'See insured shipments',
    description: 'link to view all insured shipments',
    id: 'bRCyVy',
  },
  helpLinkAutomationRules: {
    defaultMessage: 'To automatically insure shipments by specific criteria, <a>use Automation Rules</a>.',
    description: 'help link to automation rules',
    id: 'SdQ55N',
  },
  applyInsuranceToggleDetails: {
    defaultMessage: 'Automatically on every new shipment',
    description: 'additional details explaining insurance will be applied to every shipment when selected',
    id: 'o+1rw6',
  },
  applyOtherInsuranceSectionTitle: {
    defaultMessage: 'Other Insurance Options',
    description: 'title for slider that will activate additional insurance options',
    id: '+rNFgH',
  },
  applyCarrierInsuranceToggleTitle: {
    defaultMessage: 'Carrier Insurance',
    description: 'slider that will activate carrier insurance',
    id: 'BU9LK4',
  },
  applyCarrierInsuranceToggleDetails: {
    defaultMessage: 'Cover small value shipments via carrier-provided insurance.',
    description: 'additional details explaining that carrier-provided insurance is an option',
    id: 'C+XKm7',
  },
  applyOtherInsuranceToggleTitle: {
    defaultMessage: 'External Insurance',
    description: 'slider that will activate other insurance',
    id: 'A2ZP5r',
  },
  applyOtherInsuranceToggleDetails: {
    defaultMessage: 'Record any third-party insurance purchased outside of ShipStation.',
    description: 'additional details explaining that external insurance is an option',
    id: 'Q3hS0K',
  },
  listCheaper: {
    defaultMessage: 'On average 20% cheaper than protection from carriers',
    description: 'list item highlighting our insurance cost less',
    id: '3fjyou',
  },
  listFaster: {
    defaultMessage: 'Up to 20 days faster resolutions than protection from carriers',
    description: 'list item highlighting our insurance has quicker claims processing',
    id: 'idW23R',
  },
  listCoverageTypes: {
    defaultMessage: 'Covers the total value of lost, stolen or damaged goods',
    description: 'list item describing situations that are covered by this insurance',
    id: 'Zagm+m',
  },
  listCoveredCosts: {
    defaultMessage: 'Covers reshipping and return shipping costs for parcels',
    description: 'list item describing additional costs that are covered',
    id: '65usQP',
  },
  listFastPayout: {
    defaultMessage: 'Same-day assessment & instant payout',
    description: 'list item describing the fast claims processing of this insurance',
    id: 'jeyW6h',
  },
  listCoverShipments: {
    defaultMessage: 'Cover shipments up to {amount}.',
    description: 'list item discussing coverage and savings using our insurance offerings',
    id: '3iD+QG',
  },
  listClaims: {
    defaultMessage: 'Fast & easy claims without special forms and trips to the carrier.',
    description: 'list item explaining how submitting claims through our insurance offerings is fast, easy & saves money',
    id: 'd5jr42',
  },
  listInternationalCoverage: {
    defaultMessage: 'International and multi-carrier coverage.',
    description: 'list item highlighting the multiple kinds of coverage offered',
    id: 'VY7UIf',
  },
  listPayBalance: {
    defaultMessage: 'Pay with your ShipStation balance.',
    description: 'list item stating you can pay for  our insurance offerings with balance',
    id: 'UPwksK',
  },
  savePreferencesError: {
    defaultMessage: 'Failed to save insurance preferences. Please try again.',
    description: 'Error notification when saving insurance preferences fails',
    id: 'o4PDXP',
  },
});

export const parcelGuardMessages = defineMessages({
  insuranceCardTitle: {
    defaultMessage: 'Insure shipments with ParcelGuard',
    description: 'title featuring ParcelGuard insurance',
    id: 'ntOp9V',
  },
  insuranceCardDescription: {
    defaultMessage:
      'Protect your shipments with ParcelGuard. Covering almost all shipments up to {amount} in value, you can ship with peace of mind. Currency, perishables, and similar items cannot be insured. Some other products can only be insured under certain conditions.',
    description: 'description listing features of ParcelGuard insurance',
    id: '/naCa8',
  },
  insuranceCardDescriptionPostRegistration: {
    defaultMessage: 'You’re all set up with ParcelGuard! Start covering your shipments and ship with peace of mind.',
    description: 'description listing features of ParcelGuard insurance',
    id: 'ikUvyI',
  },
  addInsuranceButton: {
    defaultMessage: 'Activate ParcelGuard',
    description: 'button to add ParcelGuard insurance',
    id: '9JUtYC',
  },
  whyInsuranceTitle: {
    defaultMessage: 'Why ParcelGuard?',
    description: 'title for section listing reasons to use ParcelGuard',
    id: 'cd6w0n',
  },
  applyInsuranceSectionTitle: {
    defaultMessage: 'Apply ParcelGuard',
    description: 'title for slider that will activate ParcelGuard insurance',
    id: 'vjMp0z',
  },
  description: {
    defaultMessage:
      'Manage how and when insurance is added to your shipments. Learn more about <a>insurance settings and terms of service</a>.',
    description: 'Insurance subheading showing where to manage insurance',
    id: 'bTnynL',
  },
});

export const xCoverMessages = defineMessages({
  insuranceCardTitle: {
    defaultMessage: 'Protect shipments with Total Shipping Protection',
    description: 'title featuring xCover insurance',
    id: 'ArdCzm',
  },
  insuranceCardDescription: {
    defaultMessage:
      'Protect your shipments with Total Shipping Protection powered by XCover. Covering almost all shipments up to {amount} in value, you can ship with peace of mind.' +
      ' Currency, perishables, and similar items cannot be insured. Some other products can only be insured under certain conditions.',
    description: 'description listing features of xCover insurance',
    id: 'mIp7EI',
  },
  insuranceCardDescriptionPostRegistration: {
    defaultMessage:
      'You’re all set up with Total Shipping Protection powered by XCover! Start covering your shipments and ship with peace of mind.',
    description: 'description listing features of xCover insurance',
    id: 'iI4Dg2',
  },
  addInsuranceButton: {
    defaultMessage: 'Add Total Shipping Protection',
    description: 'button to add xCover insurance',
    id: 'Q9Zb0m',
  },
  whyInsuranceTitle: {
    defaultMessage: 'Why Total Shipping Protection?',
    description: 'title for section listing reasons to use xCover',
    id: '444CeS',
  },
  applyInsuranceSectionTitle: {
    defaultMessage: 'Apply Total Shipping Protection',
    description: 'title for slider that will activate xCover insurance',
    id: '3aBXsG',
  },
  description: {
    defaultMessage:
      'Manage how and when protection is added to your shipments. Learn more about <a>insurance settings and terms of service</a>.',
    description: 'Insurance subheading showing where to manage insurance',
    id: 'wvQSX5',
  },
});
